// An expired session or rate limiting would fail every remaining call too.
export const STOP_STATUSES = [401, 429];

// Runs fn(id) one at a time. Stops on a status in STOP_STATUSES; the remaining ids count as failed.
// reason is the first error message seen.
export async function runSequentially(ids, fn) {
  const failedIds = [];
  let reason = '';
  let stoppedBy = null;
  for (const [index, id] of ids.entries()) {
    try {
      await fn(id);
    } catch (error) {
      failedIds.push(id);
      reason = reason || error.messages?.[0] || error.response?.data?.message || '';
      if (STOP_STATUSES.includes(error.status)) {
        stoppedBy = error.status;
        failedIds.push(...ids.slice(index + 1));
        break;
      }
    }
  }
  return { failedIds, reason, stoppedBy };
}
